export default "__VITE_ASSET__CPwsX4p3__"